import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFolderArrowRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.197 4H3.5a.5.5 0 0 0-.5.5V5h4.131l-.518-.777A.5.5 0 0 0 6.197 4M2 4.5V7a.5.5 0 0 0 1 0V6h9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.02a.5.5 0 1 0-1 0V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.333l-.888-1.332A1.5 1.5 0 0 0 6.197 3H3.5A1.5 1.5 0 0 0 2 4.5m2.728 6.762a.5.5 0 0 1 0-.707l.556-.557H2.5a.5.5 0 0 1 0-1h2.792l-.564-.564a.5.5 0 0 1 .707-.708l1.414 1.415.353.353-.353.354-1.414 1.414a.5.5 0 0 1-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowRight16);
